import React from 'react';
import { MoreVertical, Trash2 } from 'lucide-react';
import { Dropdown, DropdownItem } from 'shared-portal-components-v2';

import type { ExternalUser } from '@/types/external-users.types';

import ExternalUserStatusBadge from './ExternalUserStatusBadge';
import { getCreatedByLabel } from './externalUsersLabels';

interface ExternalUsersMobileRowProps {
  user: ExternalUser;
  onDeleteRequest: (user: ExternalUser) => void;
}

function MobileField({ label, value }: { label: string; value: string }): React.ReactElement {
  return (
    <div className="flex justify-between gap-2 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-right break-all">{value}</span>
    </div>
  );
}

function ExternalUsersMobileRow({
  user,
  onDeleteRequest,
}: ExternalUsersMobileRowProps): React.ReactElement {
  return (
    <div
      className="md:hidden border-b border-border px-4 py-3 last:border-b-0"
      data-testid={`external-user-mobile-row-${user.id}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="truncate font-medium text-foreground">{user.name}</p>
          <p className="truncate text-sm text-muted-foreground">{user.email}</p>
        </div>
        <div className="flex items-center gap-2">
          <ExternalUserStatusBadge status={user.status} />
          <Dropdown
            align="end"
            trigger={
              <button
                type="button"
                className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
                aria-label={`Actions for ${user.name}`}
              >
                <MoreVertical className="h-4 w-4" />
              </button>
            }
          >
            <DropdownItem
              onSelect={() => {
                onDeleteRequest(user);
              }}
            >
              <span className="flex items-center gap-2 text-destructive">
                <Trash2 className="h-4 w-4" />
                Delete
              </span>
            </DropdownItem>
          </Dropdown>
        </div>
      </div>
      <div className="mt-2 space-y-1">
        <MobileField label="Phone" value={user.phone} />
        <MobileField label="Dept / Org" value={user.deptOrg} />
        <MobileField label="Invited by" value={getCreatedByLabel(user.createdByAccount)} />
        <MobileField label="SIXs" value={String(user.sixCount)} />
      </div>
    </div>
  );
}

export default ExternalUsersMobileRow;
